import { render, staticRenderFns } from "./GrossSalaryDeductionForInvoiceExpensesCalculation.vue?vue&type=template&id=bc1f0468"
import script from "./GrossSalaryDeductionForInvoiceExpensesCalculation.vue?vue&type=script&lang=js"
export * from "./GrossSalaryDeductionForInvoiceExpensesCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports